let inject = [
  '$scope',
  'ReportRemissionService',
  '$state',
  '$rootScope',
  'SharedService',
  '$timeout',
  'ngAuthSettings',
  'CartService',
  'SessionService',
  'NgTableParams',
  '$uibModal',
  '$filter'
];

class ReportRemissionController {
  constructor($scope,
              ReportRemissionService,
              $state,
              $rootScope,
              SharedService,
              $timeout,
              ngAuthSettings,
              CartService,
              SessionService,
              NgTableParams,
              $uibModal,
              $filter) {
    this.$state = $state;
    this.SessionService = SessionService;
    this.ngAuthSettings = ngAuthSettings;
    this.CartService = CartService;
    this.$filter = $filter;
    // this.$scope = $scope;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.NgTableParams = NgTableParams;
    this.ReportRemissionService = ReportRemissionService;
    this.$uibModal = $uibModal;
    this.SharedService = SharedService;

    this.remissions = null;
    this.state = {};
    this.branches = [];

    this.stateRemission = {};
    this.remissionSelected = null;
    this.remissionSelectedBase = null;
    this.watchingRemission = false;

    // ngTable Params
    this.ngTableConfigRemission = null;
    this.ngTableColsRemission = null;

    this.totalValueToPayRemissions = 0;
    this.totalValuePendingRemissions = 0;
    this.updatedAt = '';

    // ngTable Params
    this.ngTableConfig = null;
    this.ngTableCols = null;
    this.thirdSelected = null;
    this.branchesSelected = null;

    this.exportingData = false;
    this.exportCorrect = false;

    this.sort = null;
    this.searchText = '';
    this.sortType = 'fecha_despacho';
    this.sortReverse = true;
    this.userOrders = [];
    this.summary = [];
    this.itemsPerPage = 12;
    this.loadingUserOrders = true;
    this.loadedUserOrders = false;
    this.errorloadingUserOrders = false;
    this.currentPage = 1;
    this.actualPage = 0;
    this.filters = {};
    this.filtersCopy = {};

    this.maxSize = 5;
    this.bigTotalItems = 0;
    this.bigCurrentPage = 1;
    this.totalItemsPage = 12;
    this.statictics = {};

    this.bigTotalItemsDetails = 0;
    this.bigCurrentPageDetail = 1;
    this.totalItemsPageDetail = 12;
    this.numberDaysReport = null;
  }

  $onInit() {
    if (!this.shCtrl.globals.currentClient) this.shCtrl.globals.currentClient = {};
    if (!this.shCtrl.globals.currentClient.third) return;
    if (!this.shCtrl.globals.currentClient.third.documentNumber) return;
    let paginar = __env.adaptative === true;
    this.getRemissionStates(false, paginar);
  }

  getBranches(item) {
    this.ReportRemissionService.getBranchesByThirdId(item.id).then(response => {
      this.branches = response;
    });
  }

  getRemissionStates(manual, paginar = true,paginationInicial,paginationFinal) {
    let documentNumber = '';
    let branchCode = '';

    let limit = this.totalItemsPage;
    let page = this.bigCurrentPage;

    if (!paginar) {
      limit = "";
      page = "";
    }else{
      if (paginationInicial==undefined && paginationFinal==undefined) {
          paginationInicial   =   0;
          paginationFinal     =   limit;
      }
    }

    try {
      if (manual) {
        this.remissions = [];
        documentNumber = this.thirdSelected.nit;
        if (angular.isArray(this.branchesSelected)) {
          branchCode = this.branchesSelected;
        } else if (this.branchesSelected) {
          branchCode = [this.branchesSelected.id];
        } else {
          branchCode = [];
        }

      } else {
        documentNumber = this.shCtrl.globals.currentClient.third.documentNumber;
        branchCode = this.shCtrl.globals.currentClient.operatingCenter.code;
      }
    } catch (e) {
      return;
    }

    if (!documentNumber || !branchCode) {
      alert('Para realizar la consulta se necesita el numero de documento y el codigo de la sucursal.');
    } else {
      this.state = {};
      this.state.loading = true;
      if (manual) {
        this.ReportRemissionService.getRemissionStatesBranches(documentNumber, branchCode, this.fecha_ini, this.fecha_fin, limit, page).then(orders => {
          this.state.loading = false;
          this.state.loaded = true;
          this.remissions = orders;
          this.numberDaysReport = orders.numeroDiasConsultar;

          if (!paginar) {
            this.totalValueToPayRemissions = 0;
            this.totalValuePendingRemissions = 0;

            angular.forEach(orders.data, (item) => {              
              item.sub_total = Math.abs(item.sub_total);
            });

            angular.forEach(orders, (order) => {
              let valor_pagar = +order.valor_pagar;
              let valor_pendiente = +order.valor_pendiente;

              this.totalValueToPayRemissions = this.totalValueToPayRemissions + valor_pagar;
              this.totalValuePendingRemissions = this.totalValuePendingRemissions + valor_pendiente;
            });


            this.bigTotalItems = this.remissions.length;
          }
          this.initNgTable();

          this.updatedAt = this.$filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
        }).catch(error => {
          this.state.loading = false;
          this.state.error = true;
        });
      } else {
        this.ReportRemissionService.getRemissionStates(documentNumber, branchCode, limit, page)
          .then(orders => {

            this.state.loading = false;
            this.state.loaded = true;
            this.numberDaysReport = orders.numeroDiasConsultar;

            angular.forEach(orders.data, (item) => {              
              item.sub_total = Math.abs(item.sub_total);
            });

            this.remissions = orders.data.slice(paginationInicial,paginationFinal);

            //console.log("page: "+paginationInicial);
            //console.log("limit: "+paginationFinal);            

            this.totalValueToPayRemissions = 0;
            this.totalValuePendingRemissions = 0;
            angular.forEach(orders.data, order => {
              let valor_pagar = +order.valor_pagar;
              let valor_pendiente = +order.valor_pendiente;

              this.totalValueToPayRemissions = this.totalValueToPayRemissions + valor_pagar;
              this.totalValuePendingRemissions = this.totalValuePendingRemissions + valor_pendiente;
            });

            this.bigTotalItems = orders.total;
            this.initNgTable();
            this.updatedAt = this.$filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
          })
          .catch((error) => {
            this.state.loading = false;
            this.state.error = true;
          });
      }
    }
  }

  selectRemission(remissionSelected, paginar = true, newLimit = null,paginationInicial,paginationFinal) {
    this.watchingRemission = true;
    this.stateRemission.loading = true;
    this.remissionSelectedBase = remissionSelected;
    let documentNumber = '';
    let branchCode = '';
    let nit = '';

    let limit = this.totalItemsPageDetail;
    let page = this.bigCurrentPageDetail;

    if (!paginar) {
      limit = "";
      page = "";
    }else{
      if (paginationInicial==undefined && paginationFinal==undefined) {
          paginationInicial   =   0;
          paginationFinal     =   limit;
      }
    }
    if (newLimit != null) {
      limit = newLimit;
    }

    try {
      nit = this.thirdSelected.nit;
    } catch (e) {
    }

    if (nit) {
      documentNumber = this.thirdSelected.nit;
      if (angular.isArray(this.branchesSelected)) {
        branchCode = this.branchesSelected;
      } else if (this.branchesSelected) {
        branchCode = [this.branchesSelected.id];
      } else {
        branchCode = [];
      }

    } else {
      documentNumber = this.shCtrl.globals.currentClient.third.documentNumber;
      branchCode = this.shCtrl.globals.currentClient.operatingCenter.code;
    }

    this.ReportRemissionService.getRemissionState(documentNumber, remissionSelected.remision_id, limit, page)
      .then((remission) => {
        this.stateRemission.loading = false;
        this.stateRemission.loaded = true;

        let countTitle = 'Cantidad Despachada';
        angular.forEach(remission.data, (item) => {
          if (item.item_cantidad < 0) {
            item.item_cantidad = Math.abs(item.item_cantidad);
            countTitle = 'Cantidad Devuelta';
          }
          item.item_valor_bruto = Math.abs(item.item_valor_bruto);
          item.item_subtotal = Math.abs(item.item_subtotal);
          item.item_valor_descuento = Math.abs(item.item_valor_descuento);
          item.item_valor_impuesto = Math.abs(item.item_valor_impuesto);
        });

        //console.log("page: "+paginationInicial);
        //console.log("limit: "+paginationFinal);

        this.remissionSelected = remission.data.slice(paginationInicial,paginationFinal);
        this.bigTotalItemsDetails = remission.total;
        this.initNgTableRemission(countTitle);
      }).catch((error) => {
      this.stateRemission.loading = false;
      this.stateRemission.loaded = true;
      this.stateRemission.error = true;
    });
  }

  blurRemission() {
    this.remissionSelected = null;
    this.watchingRemission = false;
  }

  initNgTableRemission(countTitle = '') {
    /**
     * destino:                             "ORDEN DE COMPRA 30455 **23183** LO RECOGEN"
     * fecha_pedido:                  (OK)  "2016-07-18 00:00:00"
     * id:                                  248
     * item_cantidad_despachada:      (OK)  0
     * item_cantidad_pedida:          (OK)  4
     * item_centro_operacion_pedido:        1
     * item_descripcion:              (OK)  "TRIAGE CARDIAC PANEL X 25 PBS"
     * item_estado:                   (OK)  null
     * item_fecha_entrega:            (OK)  "2016-07-18 00:00:00"(OK)
     * item_referencia:               (OK)  "97000HSEU"
     * item_unidad_medida:            (OK)  "UND"
     * item_valor_descuento:          (OK)  0
     * item_valor_total:              (OK)  1800000
     * item_valor_unitario:           (OK)  450000
     * pedido_estado:                       "1"
     * pedido_id:                           "PV-150296"
     * sucursal:                            "ANGEL DIAGNOSTICA S A/CAMBULOS"
     * sucursal_id:                         "01"
     * tercero:                             "ANGEL DIAGNOSTICA S A"
     * tercero_id:                          "805013591"
     * valor_pagar:                         null
     * valor_pendiente:                     null
     * vendedor:                            "ALVAREZ ACHURY CONSTANZA VIVIANA"
     * vendedor_id:                         "0231"
     */

    this.ngTableColsRemission = [
      {
        field: "item_referencia",
        title: "Referencia",
        sortable: "item_referencia",
        filter: {"item_referencia": "text"},
        show: true
      },
      {
        field: "item_descripcion",
        title: "Descripción",
        sortable: "item_descripcion",
        filter: {"item_descripcion": "text"},
        show: true
      },
      {
        field: "item_ext1",
        title: "Extension #1",
        sortable: "item_ext1",
        filter: {"item_ext1": "text"},
        show: true
      },
      {
        field: "item_ext2",
        title: "Extension #2",
        sortable: "item_ext2",
        filter: {"item_ext2": "text"},
        show: true
      },
      {
        field: "item_unidad_medida",
        title: "U.M",
        sortable: "item_unidad_medida",
        filter: {"item_unidad_medida": "text"},
        show: true
      },
      {
        field: "item_cantidad",
        title: countTitle,
        sortable: "item_cantidad",
        filter: {"item_cantidad": "text"},
        show: true
      },
      {
        field: "item_valor_bruto",
        title:  "Valor Bruto",
        sortable: "item_valor_bruto",
        filter: {"item_valor_bruto": "text"},
        show: true
      },
      {
        field: "item_valor_descuento",
        title:  "Descuentos",
        sortable: "item_valor_descuento",
        filter: {"item_valor_descuento": "text"},
        show: true
      },
      {
        field: "item_valor_impuesto",
        title:  "Impuestos",
        sortable: "item_valor_impuesto",
        filter: {"item_valor_impuesto": "text"},
        show: true
      },
      {
        field: "item_subtotal",
        title: "Valor Neto",
        sortable: "item_subtotal",
        filter: {"item_subtotal": "text"},
        show: true
      }
    ];

    let initialParams = {
      count: 20,
      sorting: {item_fecha_entrega: "desc"}
    };

    let initialSettings = {
      counts: [5, 10, 20],
      paginationMaxBlocks: 8,
      paginationMinBlocks: 2,
      dataset: this.remissionSelected
    };

    this.ngTableConfigRemission = new this.NgTableParams(initialParams, initialSettings);
  }

  initNgTable() {

    this.ngTableCols = [
      {
        field: "remision_id",
        title: "Remisión/Devolución",
        sortable: "remision_id",
        filter: {"remision_id": "text"},
        show: true
      },
      {
        field: "factura_id",
        title: "Factura",
        sortable: "factura_id",
        filter: {"factura_id": "text"},
        show: true
      },
      {
        field: "pedido_id",
        title: "Pedido",
        sortable: "pedido_id",
        filter: {"pedido_id": "text"},
        show: true
      },
      {
        field: "centro_operacion_id",
        title: "Origen",
        sortable: "centro_operacion_id",
        filter: {"centro_operacion_id": "text"},
        show: true
      },
      {
        field: "sucursal_cliente",
        title: "Punto de Envío",
        sortable: "sucursal_cliente",
        filter: {"sucursal_cliente": "text"},
        show: true
      },
      {
        field: "direccion_despacho",
        title: "Dirección Envío",
        sortable: "direccion_despacho",
        filter: {"direccion_despacho": "text"},
        show: true
      },
      {
        field: "fecha_despacho",
        title: "Despacho",
        sortable: "fecha_despacho",
        filter: {"fecha_despacho": "text"},
        show: true
      },
      {
        field: "co_nombre",
        title: "Sucursal",
        sortable: "co_nombre",
        filter: {"co_nombre": "text"},
        show: true
      },
      {
        field: "sub_total",
        title: "Valor Neto",
        sortable: "sub_total",
        filter: {"sub_total": "text"},
        show: true
      },
      {
        field: "actions",
        title: "Detalle",
        show: true
      },
    ];

    let initialParams = {
      count: 20,
      sorting: {fecha_despacho: "desc"}
    };

    let initialSettings = {
      counts: [5, 10, 20],
      paginationMaxBlocks: 8,
      paginationMinBlocks: 2,
      dataset: this.remissions
    };

    this.ngTableConfig = new this.NgTableParams(initialParams, initialSettings);
  }

  exportExcel() {

    this.exportingData = true;
    let nameClient = this.shCtrl.globals.currentClient.third.name;
    //console.log(this.orders);
    this.ReportRemissionService.getExportExcel(this.remissions, nameClient)
      .then((datos) => {
        console.log(datos.data.url_excel);
        //open(datos.data.url_excel);
        open(datos.data.url_excel, '_blank');
        this.exportingData = false;
        this.exportCorrect = true;

      }).catch((error) => {
      this.exportingData = false;
      this.exportCorrect = false;
    });
  }

  showSort(value) {
    this.sort = value;
  }
}

ReportRemissionController.$inject = inject;

export default ReportRemissionController;



/** WEBPACK FOOTER **
 ** ./www/components/reports/remission/remission.controller.js
 **/